import {
  EChartTimeFormat,
  TChartTimeFormatTranslation,
} from './select-chart-time-format.ts';

const chartTimeFormats: TChartTimeFormatTranslation = {
  [EChartTimeFormat.COMPACT]: {
    displayName: 'Kompaktowy',
    details: 'Wyświetla tylko czas dla przedziałów czasowych krótszych niż 24 godziny',
  },
  [EChartTimeFormat.DETAILED]: {
    displayName: 'Szczegółowy',
    details: 'Zawsze wyświetla pełną datę',
  },
};

export default {
  placeholder: 'Wybierz format czasu wykresu',
  chartTimeFormats,
};
